import { SET_AVAILABLE_BUSINESS_UNITS, SET_BUSINESS_UNIT, SET_USER_SELECTED_ROLE, UserDataActionTypes } from './types';
import { UserDataState } from '../../types/UserData';
import { updateItemInStorage } from '../../util/sessionStorage';
import { BusinessCentres } from '@cambridgeassessment/lib-ee-commons';

const initialState: UserDataState = {
  selectedRole: null,
  businessUnit: JSON.parse(sessionStorage.getItem('businessUnit') || 'null'),
  availableBusinessUnits: [],
};

export default (state: UserDataState = initialState, action: UserDataActionTypes): UserDataState => {
  switch (action.type) {
    case SET_USER_SELECTED_ROLE: {
      return {
        ...state,
        selectedRole: action.payload,
      };
    }

    case SET_BUSINESS_UNIT: {
      const { businessUnit } = action.payload;
      updateItemInStorage('businessUnit', JSON.stringify(businessUnit));

      return {
        ...state,
        businessUnit,
      };
    }

    case SET_AVAILABLE_BUSINESS_UNITS: {
      const { businessUnits } = action.payload;
      const sortedBusinessUnits = [...businessUnits];

      const sortFn = (bu1: BusinessCentres, bu2: BusinessCentres) => bu1.fullName.localeCompare(bu2.fullName);

      sortedBusinessUnits.sort(sortFn);

      return {
        ...state,
        availableBusinessUnits: sortedBusinessUnits,
      };
    }
    default:
      return state;
  }
};
